const hamburger = document.querySelector(".hamburger--js");
hamburger.addEventListener("click", ()=>{
    console.log("\uD83C\uDF54");
    const navigation = document.querySelector(".navigation--js");
    navigation.classList.toggle("navigation--open");
});

//# sourceMappingURL=form.5faaf861.js.map
